const getSearchParams = (): URLSearchParams => {
	if ( typeof window === "undefined" ) {
		return new URLSearchParams()
	}

	return new URLSearchParams(window.location.search)
}

const getOverrideValue = (keys: string[]): string | null => {
	const params = getSearchParams()

	for ( const key of keys ) {
		const value = params.get(key)
		if ( value && value.trim() !== "" ) {
			return value.trim()
		}
	}

	return null
}

const getCombinedOverrideValue = (): string | null => {
	return getOverrideValue([ "hostvertaaensinreferrer" ])
}

const normalizeCombinedHostValue = (value: string): string => {
	let host = value.trim()

	if ( host.startsWith("http://") || host.startsWith("https://") ) {
		try {
			return new URL(host).hostname.toLowerCase()
		} catch {
			// Fall back to manual parsing below.
		}
	}

	host = host.split("/")[0].split("?")[0].split("#")[0]
	if ( !host.includes(".") ) {
		host = `${host}.fi`
	}

	return host.toLowerCase()
}

const normalizeReferrerValue = (value: string): string => {
	const referrer = value.trim()

	if ( referrer.startsWith("http://") || referrer.startsWith("https://") ) {
		return referrer
	}

	return `https://${normalizeCombinedHostValue(referrer)}/`
}

export const getHostnameOverride = (): string | null => {
	const combinedOverride = getCombinedOverrideValue()
	if ( combinedOverride ) {
		return normalizeCombinedHostValue(combinedOverride)
	}

	const override = getOverrideValue([ "host", "hostname" ])
	return override ? override.toLowerCase() : null
}

export const getReferrerOverride = (): string | null => {
	const combinedOverride = getCombinedOverrideValue()
	if ( combinedOverride ) {
		return normalizeReferrerValue(combinedOverride)
	}

	const override = getOverrideValue([ "referrer", "ref" ])
	return override ? normalizeReferrerValue(override) : null
}

export const getRuntimeHostname = (): string => {
	if ( typeof window === "undefined" ) {
		return ""
	}

	return (getHostnameOverride() ?? window.location.hostname).toLowerCase()
}

export const getRuntimeReferrer = (): string => {
	if ( typeof window === "undefined" ) {
		return ""
	}

	const override = getReferrerOverride()
	if ( override ) {
		return override
	}

	return document.referrer == "" ? "https://vakuutuslaskuri.fi/" : document.referrer
}

export const isVertaaensinHost = (): boolean => {
	return getRuntimeHostname().includes("vertaaensin")
}
